import { useState, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"

import { Modal, message } from "antd"
import ReCAPTCHA from "react-google-recaptcha"
import { useRequestFreeTrialMutation } from "./freeTrialApiSlice"
import { showSpinner, hideSpinner } from "../../components/componentSlice"

import './FreeTrialForm.css'

const FreeTrialForm = ({ isModalOpen, onClose }) => {
    const dispatch = useDispatch()

    const [name, setName] = useState(null)
    const [company, setCompany] = useState(null)
    const [email, setEmail] = useState(null)
    const [captchaToken, setCaptchaToken] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const captchaRef = useRef(null);

    const [ requestFreeTrial,  {
        isLoading,
        isSuccess
    }] = useRequestFreeTrialMutation()

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])

    useEffect(() => {
        if(isSuccess) {
            alertMessage("Thank you for your request! A relationship manager will be in touch with you shortly.")
        }
    }, [isSuccess])

    const [messageApi, contextHolder] = message.useMessage()
    
    const alertMessage = (message) => {
        messageApi.success(message)
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        setErrorMessage(null)

        if (!captchaToken) {
            setErrorMessage("Please complete the CAPTCHA.")
            return
        }

        if(!name || !company || !email) {
            return
        }

        try {
            let request = {
                name, 
                company, 
                email, 
                captcha: captchaToken}

            await requestFreeTrial(request).unwrap()
            resetForm()
        } catch(err) {
            setErrorMessage(err.data?.message)
        }
    }

    const resetForm = () => {
        setName("")
        setCompany("")
        setEmail("")
        captchaRef.current.reset()
    }

    return (
        <Modal open={isModalOpen} onCancel={() => onClose()} footer={[]}>
            <div className="free-trial-form-content">
                <div className="free-trial-form-header">
                    <h2>Request Your Free Trial Now!</h2>
                </div>
                <p className='errorMessage'>{errorMessage}</p>
                <form onSubmit={(e) => onSubmit(e)}>
                    {contextHolder}
                    <div className="form-group">
                        <label for="name">Name</label>
                        <input className="inpt" type="name" id="name" name="name" required  value={name} onChange={(e) => setName(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label for="company">Company</label>
                        <input className="inpt" type="company" id="company" name="company" required  value={company} onChange={(e) => setCompany(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label for="email">Email Address</label>
                        <input className="inpt" type="email" id="email" name="email" required  value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    <div className="captcha">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={(token) => setCaptchaToken(token)}
                            ref={captchaRef}
                        />
                    </div>

                    <div className="form-group">
                        <button className="crm-button">Submit</button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default FreeTrialForm